import { render, staticRenderFns } from "./Summary.vue?vue&type=template&id=447d36e5&"
import script from "./Summary.vue?vue&type=script&lang=js&"
export * from "./Summary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('447d36e5')) {
      api.createRecord('447d36e5', component.options)
    } else {
      api.reload('447d36e5', component.options)
    }
    module.hot.accept("./Summary.vue?vue&type=template&id=447d36e5&", function () {
      api.rerender('447d36e5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/bespoke/pages/Accounts/Summary.vue"
export default component.exports